import Vue from "vue";
import base from "../baseMarketing";

export default Object.assign(
    {
        apiUrl: "/plan",

        async list({ page = 0 }) {
            const url = this.url(`/page/${page}`);
            return Vue.http.get(url);
        },

        async create({ name, smsAmount, emailAmount }) {
            const url = this.url(`/`);
            return Vue.http.post(url, {
                name,
                smsAmount,
                emailAmount,
                // whatsappAmount
            });
        },

        async edit({ planId, name, smsAmount, emailAmount }) {
            const url = this.url(`/${planId}`);
            
            return Vue.http.put(url, {
                name,
                smsAmount,
                emailAmount,
                // whatsappAmount
            });
        },

        async delete({ planId }) {
            const url = this.url(`/${planId}`);
            
            return Vue.http.delete(url);
        },
    },
    base
);
